import { Option, OptionGroup, SelectorValues } from '@legacy/types/SelectorValues'

const SHIPPING_PRODUCT_SLUGS = ['cargo', 'parcel', 'sendcover']

export function isShippingProductSlug(slug: string): boolean {
  return SHIPPING_PRODUCT_SLUGS.includes(slug)
}

/**
 * Our API sends arrays of acceptable values for a parameter in the as objects
 * with keys `identifier` and `label`. This function transforms an array of
 * those items to an array that can easily be used to generate form select
 * components
 */
export const prepareParameterInfoForOptions = (items?: SelectorValues[]): Option[] => {
  if (!items) return []

  return items.map((item) => ({
    value: item.identifier,
    text: item.label ?? '',
    data: item.data,
  }))
}

/**
 * Our API sends arrays of acceptable values for a parameter in the as objects
 * with keys `identifier` and `label`. This function transforms an array of
 * those items to an array that can easily be used to generate form select
 * components
 */
export const prepareOptionsForGroupedOptions = (groupBy: string, items: Option[]): OptionGroup[] => {
  const optionObject: { [key: string]: OptionGroup } = {}

  items.forEach((option) => {
    const key = option.data[groupBy]
    // eslint-disable-next-line
    if (optionObject.hasOwnProperty(key)) {
      optionObject[key].options.push(option)
    } else {
      optionObject[key] = { text: key, options: [option] }
    }
  })

  return Object.values(optionObject)
}
